import { StateUtils } from '@spartacus/core';

export const SEO_FEATURE = 'seo';
export const PAGE = '[Seo] Page';

export interface StateWithSeo {
  [SEO_FEATURE]: SeoState;
}

export interface SeoState {
  page: StateUtils.LoaderState<SeoPageState | null>;
}

export interface SeoPageState {
  urlOrLabel: string;
  seo: {
    metaTitle: string;
    metaDescription: string;
    keywords?: string;
    metaRobots?: any;
    structuredData?: any;
    metaViewport?: string;
    canonicalURL?: string;
    h1?: string;
    breadcrumbTitle?: string;
  };
}
